// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackStartQuickOrderListUploadParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackStartQuickOrderListUpload";

const useTrackStartQuickOrderListUpload = (
    parameters: TrackStartQuickOrderListUploadParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.startQuickOrderListUpload, parameters, options);
};

export default useTrackStartQuickOrderListUpload;
